import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { FloorFilter } from '../../../../models/Filter';
import { FloorFilterView } from '../../floor/FloorFilter';

interface IMobileFloorFilter {
    filter: FloorFilter;
    handleChange: (value: FloorFilter) => void;
    classNameGroup?: string;
    classNameSubGroup?: string;
}

export const MobileFloorFilterButtonView: React.FC<IMobileFloorFilter> = ({
    filter,
    handleChange,
    classNameGroup,
    classNameSubGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Этаж'>
            <FloorFilterView
                withoutTitle
                withoutGrid
                classNameGroup={classNameGroup}
                filter={filter}
                handleChange={handleChange}
                classNameSubGroup={classNameSubGroup}
            />
        </MobileFilter2>
    );
};
